import React, { FormEvent, useState } from "react";
import { reportChapters } from "../../data/research";
type Status = "idle" | "submitting" | "success" | "error";
export function ReportPreview() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      return;
    }
    setStatus("submitting");
    await new Promise(r => setTimeout(r, 900));
    setStatus("success");
  };
  return <section id="state-of-payroll" aria-labelledby="report-title" className="scroll-mt-28 bg-navy text-ivory" data-id="element-538" data-mp="qom6eha3wh8f">
      <div className="shell py-24 md:py-32" data-id="element-539" data-mp="hluu6f9ephfq">
        <div className="grid grid-cols-12 gap-x-6 gap-y-14" data-id="element-540" data-mp="hmwfrdo1tmbp">
          <div className="col-span-12 lg:col-span-6" data-id="element-541" data-mp="2gz8q0dpjkrw4">
            <p className="eyebrow text-ivory/75" data-id="element-542" data-mp="2gxxl2akd1e3f">Annual report · Publishing January 2027</p>
            <h2 id="report-title" className="mt-8 font-display text-[clamp(2.5rem,5vw,4.5rem)] leading-[1.02]" data-id="element-543" data-mp="2c0dxgk1rvoyt">
              The State of Payroll Operations
            </h2>
            <p className="mt-4 font-display text-3xl italic text-ivory/80" data-id="element-544" data-mp="qvsatfcjbj43">2026 edition</p>
            <p className="mt-8 max-w-md leading-relaxed text-ivory/70" data-id="element-545" data-mp="cvpvo0vm33sj">
              Our annual study of how payroll and HR technology teams are staffed, run, and supported — and where they
              break.
            </p>

            {status === "success" ? <p role="status" className="mt-12 max-w-md border-t border-ivory/25 pt-6 text-ivory" data-id="element-546" data-mp="19l7ab5cko06d">
                Noted. A copy will be sent to {email} on publication.
              </p> : <form onSubmit={handleSubmit} noValidate className="mt-12 max-w-md" data-id="element-547" data-mp="10sncg743tzml">
                <label htmlFor="report-email" className="eyebrow text-ivory/75" data-id="element-548" data-mp="1oihm6ft4n82m">
                  Request a copy
                </label>
                <div className="mt-4 flex border-b border-ivory/40 focus-within:border-ivory" data-id="element-549" data-mp="1t9g7xuwvwyd9">
                  <input id="report-email" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                if (status === "error") setStatus("idle");
              }} placeholder="Work email" aria-invalid={status === "error"} aria-describedby={status === "error" ? "report-error" : undefined} className="min-w-0 flex-1 bg-transparent py-3 text-ivory placeholder:text-ivory/40 focus:outline-none" data-id="element-550" data-mp="235gc26cc5uf8" />
                  <button type="submit" disabled={status === "submitting"} className="shrink-0 py-3 pl-4 text-[12px] font-semibold uppercase tracking-[0.18em] text-ivory transition-opacity duration-150 disabled:opacity-60" data-id="element-551" data-mp="1agskxu4woatr">
                    {status === "submitting" ? "Sending…" : "Request"}
                  </button>
                </div>
                {status === "error" && <p id="report-error" className="mt-3 text-sm text-ivory/80" data-id="element-552" data-mp="3c4x3wcukykap">
                    Enter a valid work email.
                  </p>}
              </form>}
          </div>

          <div className="col-span-12 lg:col-span-5 lg:col-start-8" data-id="element-553" data-mp="3m2jmb9b38tzf">
            <p className="eyebrow text-ivory/75" data-id="element-554" data-mp="2ogm8vqbkfeuc">Contents</p>
            <ol className="mt-6 border-t-2 border-oxblood" data-id="element-555" data-mp="2oe15uxzj6sv0">
              {reportChapters.map((c, i) => <li key={c} className="flex gap-6 border-b border-ivory/15 py-5" data-id="element-556" data-mp="2tcuhslz66bt2" data-mpi={i}>
                  <span className="w-6 shrink-0 font-display tabular-nums text-ivory/50" data-id="element-557" data-mp="2ycyyod3zp8jt">{i + 1}</span>
                  <span className="font-display text-xl leading-snug text-ivory" data-id="element-558" data-mp="3373956cgrypn">{c}</span>
                </li>)}
            </ol>
          </div>
        </div>
      </div>
    </section>;
}